import { ModalOrderEditStoreInterface } from '@/store/ModalOrderEditStore'
import { modalOrderEditStore } from '@/utils/store-accessor'

export class ModalOrderEditService {
  public open(params?: ModalOrderEditStoreInterface) {
    modalOrderEditStore.open(params)
  }

  public close() {
    modalOrderEditStore.close()
  }
}
